module.exports = __webpack_public_path__ + "static/media/all-activities.01b05fa7.svg";